import { createSlice, PayloadAction } from "@reduxjs/toolkit";


import { archiveArticle, changeArticleStatus, deleteArticle, getArchivedOptimizedArticles, getArticleStatus, getCompetitors, getOptimizedArticles, optimizeArticle, rewriteArticle, unarchiveArticle } from "./thunks";


import {
  OptimizeArticleType,
  OptimizedContentState
} from "./types";

const initialLoadingState = {
  ["optimizeContent/optimizeArticle"]: "idle",
  ["optimizeContent/getOptimizedArticles"]: "idle",
  ["optimizeContent/getCompetitors"]: "idle",
  ["optimizeContent/getArticleStatus"]: "idle",
  ["optimizeContent/archiveArticle"]: "idle",
  ["optimizeContent/unarchiveArticle"]: "idle",
  ["optimizeContent/deleteArticle"]: "idle",
  ["optimizeContent/getArchivedOptimizedArticles"]: "idle",
  ["optimizeContent/rewriteArticle"]: "idle",
  ["optimizeContent/changeArticleStatus"]: "idle",

};

const initialState: OptimizedContentState = {
  optimizedArticles: [],
  archivedOptimizedArticles: [],
  loading: initialLoadingState,
  error: null,
  limit: 0,
  page: 0,
  total: 0,


};







export const optimizeContentSlice = createSlice({
  name: "optimizeContent",
  initialState,
  reducers: {
    setOptimizeContent: (state, action: PayloadAction<OptimizeArticleType>) => {
      state.optimizedArticles.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(optimizeArticle.pending, (state) => {
        state.loading["optimizeContent/optimizeArticle"] = "pending";
      })
      .addCase(optimizeArticle.rejected, (state, action) => {
        state.loading["optimizeContent/optimizeArticle"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(optimizeArticle.fulfilled, (state, action) => {
        state.loading["optimizeContent/optimizeArticle"] = "finished";
        //add it to the top of the list
        state.optimizedArticles.unshift(action.payload?.data);

      })
      .addCase(getCompetitors.fulfilled, (state, action) => {
        // state.optimizedArticles.competitors = action.payload;
      })




      //rewriteArticle
      .addCase(rewriteArticle.pending, (state) => {
        state.loading["optimizeContent/rewriteArticle"] = "pending";
      })
      .addCase(rewriteArticle.rejected, (state, action) => {
        state.loading["optimizeContent/rewriteArticle"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(rewriteArticle.fulfilled, (state, action) => {
        state.loading["optimizeContent/rewriteArticle"] = "finished";
        //refresh the article with the new data
        state.optimizedArticles = state.optimizedArticles.map((item) => {
          if (item.id === action.payload.data?.id) {
            return action.payload?.data;
          }
          return item;
        }
        );

      })

      //change article status
      .addCase(changeArticleStatus.pending, (state) => {
        state.loading["optimizeContent/changeArticleStatus"] = "pending";
      })
      .addCase(changeArticleStatus.rejected, (state, action) => {
        state.loading["optimizeContent/changeArticleStatus"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(changeArticleStatus.fulfilled, (state, action) => {
        state.loading["optimizeContent/changeArticleStatus"] = "finished";
        state.optimizedArticles = state.optimizedArticles.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload?.data;
          }
          return item;
        }
        );
      })


      .addCase(getOptimizedArticles.pending, (state) => {
        state.loading["optimizeContent/getOptimizedArticles"] = "pending";
      })
      .addCase(getOptimizedArticles.rejected, (state, action) => {
        state.loading["optimizeContent/getOptimizedArticles"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(getOptimizedArticles.fulfilled, (state, action) => {
        state.loading["optimizeContent/getOptimizedArticles"] = "finished";
        state.optimizedArticles = action.payload?.data;
        state.limit = action.payload.limit ?? 50;
        state.total = action.payload.total_count ?? 0;
        state.page++;
      })
      //getArchivedOptimizedArticles
      .addCase(getArchivedOptimizedArticles.pending, (state) => {
        state.loading["optimizeContent/getArchivedOptimizedArticles"] = "pending";
      })
      .addCase(getArchivedOptimizedArticles.rejected, (state, action) => {
        state.loading["optimizeContent/getArchivedOptimizedArticles"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(getArchivedOptimizedArticles.fulfilled, (state, action) => {
        state.loading["optimizeContent/getArchivedOptimizedArticles"] = "finished";
        state.archivedOptimizedArticles = action.payload?.data;
        state.limit = action.payload.limit ?? 50;
        state.total = action.payload.total_count ?? 0;
        state.page++;
      })
      //archive
      .addCase(archiveArticle.pending, (state) => {
        state.loading["optimizeContent/archiveArticle"] = "pending";
      })
      .addCase(archiveArticle.rejected, (state, action) => {
        state.loading["optimizeContent/archiveArticle"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(archiveArticle.fulfilled, (state, action) => {
        state.loading["optimizeContent/archiveArticle"] = "finished";
        //remove the article from the optimizedArticles
        state.optimizedArticles = state.optimizedArticles.filter((item) => item.id !== action.payload.id);


      })
      //unarchive
      .addCase(unarchiveArticle.pending, (state) => {
        state.loading["optimizeContent/unarchiveArticle"] = "pending";
      })
      .addCase(unarchiveArticle.rejected, (state, action) => {
        state.loading["optimizeContent/unarchiveArticle"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(unarchiveArticle.fulfilled, (state, action) => {
        state.loading["optimizeContent/unarchiveArticle"] = "finished";
        state.archivedOptimizedArticles = state.archivedOptimizedArticles.filter((item) => item.id !== action.payload.id);
      })
      //delete
      .addCase(deleteArticle.pending, (state) => {
        state.loading["optimizeContent/deleteArticle"] = "pending";
      })
      .addCase(deleteArticle.rejected, (state, action) => {
        state.loading["optimizeContent/deleteArticle"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(deleteArticle.fulfilled, (state, action) => {
        state.loading["optimizeContent/deleteArticle"] = "finished";
        state.optimizedArticles = state.optimizedArticles.filter((item) => item.id !== action.payload.id);
      })
      //get article status
      .addCase(getArticleStatus.pending, (state) => {
        state.loading["optimizeContent/getArticleStatus"] = "pending";
      })
      .addCase(getArticleStatus.rejected, (state, action) => {
        state.loading["optimizeContent/getArticleStatus"] = "finished";
        state.error = action.error.message ?? null;
      })
      .addCase(getArticleStatus.fulfilled, (state, action) => {
        state.loading["optimizeContent/getArticleStatus"] = "finished";
        state.optimizedArticles = state.optimizedArticles.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload?.data;
          }
          return item;
        }
        );
      })



  },



});


export const { setOptimizeContent } = optimizeContentSlice.actions;
export default optimizeContentSlice.reducer;
export * from "./selectors";
export * from "./thunks";
